/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Catalog_CardInputs */

const cs_property_ai_catalog_card = /** @type {(inputs: Property_Ai_Catalog_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygenerovat katalogové PDF`)
};

const en_property_ai_catalog_card = /** @type {(inputs: Property_Ai_Catalog_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate catalog PDF`)
};

/**
* | output |
* | --- |
* | "Generate catalog PDF" |
*
* @param {Property_Ai_Catalog_CardInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_catalog_card = /** @type {((inputs?: Property_Ai_Catalog_CardInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Catalog_CardInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_catalog_card(inputs)
	return cs_property_ai_catalog_card(inputs)
});